import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';

import ContactUsContent from '../../components/Pages/ContactUs';

const { displayName } = config;

export default function ContactUs(): React.ReactElement {
  document.title = `${displayName}: Contact Us`;

  return (
    <Layout>
      <ContactUsContent />
    </Layout>
  );
}
